export default "__VITE_ASSET__CHiVZ7iC__"